import { BlogIndexPage } from 'components/blog/blog-index-page';
import { BlogWrapper } from 'components/blog/blog-wrapper';
import { fetchTaggedArticles } from 'queries';

const ChangelogRoute = ({ ssr, router, session, store, toast }) => {
	// Render
	return <BlogIndexPage title='Changelog' ssr={ssr} />;
};

ChangelogRoute.getLayout = (page, ssr) => {
	const tag = ssr.tag?.data || {};
	return <BlogWrapper seo={{ description: tag.description }}>{page}</BlogWrapper>;
};

export async function getServerSideProps({ params, query }) {
	const articles = await fetchTaggedArticles('changelog', { params, query });
	return { props: { articles } };
}

export default ChangelogRoute;
